import { DeviceInfo } from '../../interface';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace MediaActions {
    export class LoadAvailableMicDevices {
        static readonly type = '[Media] Load Available Mic Devices';
    }

    export class LoadAvailableCameraDevices {
        static readonly type = '[Media] Load Available Camera Devices';
    }

    export class LoadAvailableAudioDevices {
        static readonly type = '[Media] Load Available Audio Devices';
    }

    export class InitLocalMedia {
        static readonly type = '[Media] Init Local Media';
    }

    export class DestroyLocalMedia {
        static readonly type = '[Media] Destroy Local Media';
    }

    export class ToggleMic {
        static readonly type = '[Media] Toggle Mic';
    }

    export class SetSelectedMicDevice {
        static readonly type = '[Media] Set Mic Device';

        constructor(public device: DeviceInfo) {}
    }

    export class ToggleCamera {
        static readonly type = '[Media] Toggle Camera';
    }

    export class SetSelectedCameraDevice {
        static readonly type = '[Media] Set Camera Device';

        constructor(public device: DeviceInfo) {}
    }

    export class ToggleAudio {
        static readonly type = '[Media] Toggle Audio';
        constructor(public volume?: number) {}
    }

    export class SetAudioDevices {
        static readonly type = '[Media] Set Audio Devices';

        constructor(public devices: DeviceInfo[]) {}
    }

    export class SetMicDevices {
        static readonly type = '[Media] Set Mic Devices';

        constructor(public devices: DeviceInfo[]) {}
    }

    export class SetCameraDevices {
        static readonly type = '[Media] Set Camera Devices';

        constructor(public devices: DeviceInfo[]) {}
    }

    export class SetSelectedAudioDevice {
        static readonly type = '[Media] Set Audio Device';

        constructor(public device: DeviceInfo) {}
    }
}
